export enum DeductbleType {
    Unknown = "Unknown",
    ArtificialJuridicalPerson = "Artificial Juridical Person",
    AssociationofPersons = 'Association of Persons',
    BodyofIndividuals = "Body of Individuals",
    CompanyResident = "Company-Resident",
    CompanyNonResident='Company - Non Resident',
    CoOperativeSocietyNonResident ="Co-Operative Society - Non Resident",
    CoOperativeSocietyResident ="Co-Operative Society - Resident",
    Government ="Government",
    IndividualHUFNonResident ="Individual/HUF - Non Resident",
    IndividualHUFResident="Individual/HUF - Resident",
    LocalAuthority = "Local Authority",
    PartnershipFirm ="Partnership Firm"
}
